import { render } from "./ModalReportTransfer.vue?vue&type=template&id=8efde680"
import script from "./ModalReportTransfer.vue?vue&type=script&lang=js"
export * from "./ModalReportTransfer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__